<!--
 * @Author: zhechuan.Wang
 * @Date: 2023-11-24 09:20:55
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2024-01-03 14:03:23
 * @Description: 页面头部
 * @FilePath: \gfmis-card-ppt\src\components\headCom.vue
-->
<template>
  <div class="head-root">
    <div class="head-box">
      <img class="headImg" :src="headerImg" />
      <div class="headSlot">
        <p class="title">海南省惠民惠农财政补贴资金公开公示平台</p>
      </div>
      <slot name="headSlot"></slot>
    </div>
    <div class="head-content">
      <div class="backBlock" v-if="isShowBack">
        <div class="back" @click="handleBack">
          <img class="backImg" src="@/assets/images/back.png" />
          <div class="backTv">返回</div>
        </div>
      </div>
      <slot name="tableHeadBefor"></slot>
      <div class="titleBlock" :style="{ paddingTop: !isShowBack ? '60px' : '0px' }">
        <div class="titleBlock-left">
          <img src="@/assets/images/u3.png" />
        </div>
        <div class="titleBlock-title">{{ headObj.cnTitleName }}
          <!-- <div class="englishTv">{{ headObj.enTitleName }}</div> -->
        </div>
        <div class="titleBlock-right">
          <img src="@/assets/images/u4.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mainHeadImgBg from '@/assets/images/header-bg2.png';
import headImgJsBg from '@/assets/images/head-jsbg.png';

export default {
  props: {
    minWidth: { type: String, default: '1650px' },
    comWidth: { type: String, default: '1500px' },
    headerImgBgName: { type: String, default: 'maitian' },
    isShowBack: { type: Boolean, default: true },
    headObj: {
      type: Object, default: () => ({
        cnTitleName: '', // 中文名称
        enTitleName: '', // 英文名称
      })
    },
  },
  data() {
    return {
      headerImg: '',
      HEAD_IMG: {
        'maitian': mainHeadImgBg,
        'jsbg': headImgJsBg
      },
    }
  },
  mounted() {
    this.headerImg = this.HEAD_IMG[this.headerImgBgName]
  },
  methods: {
    handleBack() {
      this.$router.back();
    }
  }
}
</script>

<style lang="scss" scoped>
.head-root {
  background-color: #f5f5f5;
}

.head-content {
  margin: 0 100px;
  background-color: white;
}

.head-box {
  position: relative;

  .headImg {
    width: 100%;
    height: 140px;
    object-fit: cover;
  }

  .headSlot {
    width: 100%;
    height: 100%;
    font-family: initial;
    font-weight: 700;
    font-size: 48px;
    color: #1271c3;
    text-align: center;
    position: absolute;
    bottom: 22px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .title {
      width: 962px;
      margin: 0 auto;
      text-shadow: 2px 0 0 white, 0 -1px white, -1px 0 white, 0 2px white;
    }
  }
}

.backBlock {
  padding-top: 10px;

  .back {
    width: 60px;
    margin-left: 20px;
    display: flex;
    cursor: pointer;

    .backImg {
      height: 19px;
      margin-right: 5px;
    }

    .backTv {
      font-size: 16px;
      color: #7cb5f5;
      margin: auto 0;
    }
  }
}

.titleBlock {
  display: flex;

  &-left {
    flex: 1;
    // height: 0px;
    margin: auto 0;

    img {
      width: 100%;
    }
  }

  &-right {
    flex: 1;
    // height: 0px;
    margin: auto 0;

    img {
      width: 100%;
    }
  }

  &-title {
    margin: 0 20px;
    text-align: center;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
    font-weight: 700;
    font-size: 30px;

    .englishTv {
      font-size: 16px;
      font-family: '微软雅黑';
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>